import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { finalize } from 'rxjs/operators'
import { Toaster } from '@tokeet-frontend/tv3-platform'
import { ChannelsService, VrboAvailabilityConfig } from '@tokeet-frontend/channels'

@Component({
  selector: 'app-homeaway-listing-details-dialog',
  templateUrl: './homeaway-listing-details-dialog.component.html',
  styleUrls: ['./homeaway-listing-details-dialog.component.scss'],
})
export class HomeAwayListingDetailsDialogComponent implements OnInit {
  form: FormGroup
  isLoading = true
  isSaving = false

  changeOverOptions = [
    { value: 'C', label: 'Check-in/out Allowed' },
    { value: 'I', label: 'Check-in Only' },
    { value: 'O', label: 'Check-out Only' },
    { value: 'X', label: 'No Check-in/out' },
  ]

  stayIncrementOptions = [
    { value: 'D', label: 'Day' },
    { value: 'W', label: 'Week' },
    { value: 'M', label: 'Month' },
    { value: 'Y', label: 'Year' },
  ]

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { rentalId: string },
    private dialogRef: MatDialogRef<HomeAwayListingDetailsDialogComponent>,
    private fb: FormBuilder,
    private channelsService: ChannelsService,
    private toaster: Toaster
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      // 0 = no prior notice required
      min_prior_notify: [
        1,
        [Validators.required, Validators.min(0), Validators.max(999), Validators.pattern('^[0-9]+$')],
      ],
      // 0 = use the rental's base rate min/max stay
      min_stay: [0, [Validators.min(0), Validators.max(999), Validators.pattern('^[0-9]+$')]],
      max_stay: [0, [Validators.min(0), Validators.max(999), Validators.pattern('^[0-9]+$')]],
      availability_default: ['N'],
      change_over: ['C'],
      stay_increment: ['D'],
    })

    this.channelsService
      .getVrboAvailabilityConfig(this.data.rentalId)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (config) => this.form.patchValue(config),
        error: () => this.toaster.error($localize`Could not load availability config`),
      })
  }

  onSave() {
    if (this.form.invalid) return
    this.isSaving = true
    const payload: VrboAvailabilityConfig = this.form.getRawValue()
    this.channelsService
      .updateVrboAvailabilityConfig(this.data.rentalId, payload)
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe({
        next: () => {
          this.toaster.success($localize`Availability config updated`)
          this.dialogRef.close(true)
        },
        error: (err) => this.toaster.error($localize`Could not save availability config`, '', err),
      })
  }

  close() {
    this.dialogRef.close()
  }
}
